import { BaseFieldConfig, ComponentNameEnum, BackgroundImageOptionTypeEnum } from '@/types';

const getBackgroundImageFieldConfig = (type: BackgroundImageOptionTypeEnum): BaseFieldConfig => {
  const componentName = ComponentNameEnum.BACKGROUND_IMAGE;
  if (type === BackgroundImageOptionTypeEnum.SELECTOR) {
    return {
      componentName,
      options: {
        type,
        list: [],
        label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.label',
        options: [
          {
            label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.options.fullWidth',
            value: 'full-width',
          },
          {
            label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.options.centerOnly',
            value: '.container',
          },
        ],
        defaultValue: 'full-width',
      },
    };
  } if (type === BackgroundImageOptionTypeEnum.SELECTOR_WITH_OPTIONS) {
    return {
      componentName,
      options: {
        type,
        label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.label',
        options: [
          {
            label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.options.fullWidth',
            value: 'full-width',
          },
          {
            label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.options.centerOnly',
            value: '.container',
          },
        ],
        defaultValue: 'full-width',
        list: [
          {
            type: 'background-size',
            label: 'templateBuilder.fields.backgroundImageOptions.size.label',
            options: [
              {
                label: 'templateBuilder.fields.backgroundImageOptions.size.options.auto',
                value: 'auto',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.size.options.cover',
                value: 'cover',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.size.options.contain',
                value: 'contain',
              },
            ],
            defaultValue: 'cover',
          },
          {
            type: 'background-position',
            label: 'templateBuilder.fields.backgroundImageOptions.position.label',
            options: [
              {
                label: 'templateBuilder.fields.backgroundImageOptions.position.options.center',
                value: 'center',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.position.options.top',
                value: 'top',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.position.options.bottom',
                value: 'bottom',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.position.options.left',
                value: 'left',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.position.options.right',
                value: 'right',
              },
            ],
            defaultValue: 'center',
          },
          {
            type: 'background-repeat',
            label: 'templateBuilder.fields.backgroundImageOptions.filling.label',
            options: [
              {
                label: 'templateBuilder.fields.backgroundImageOptions.filling.options.noRepeat',
                value: 'no-repeat',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.filling.options.repeat',
                value: 'repeat',
              },
            ],
            defaultValue: 'no-repeat',
          },
        ],
      },
    };
  } if (type === BackgroundImageOptionTypeEnum.NO_OPTION) {
    return {
      componentName,
      options: {
        type,
        list: [],
        label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.label',
      },
    };
  } if (type === BackgroundImageOptionTypeEnum.SIZE_REPEAT) {
    return {
      componentName,
      options: {
        type,
        list: [
          {
            type: 'background-size',
            label: 'templateBuilder.fields.backgroundImageOptions.size.label',
            options: [
              {
                label: 'templateBuilder.fields.backgroundImageOptions.size.options.cover',
                value: 'cover',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.size.options.auto',
                value: 'auto',
              },
            ],
            defaultValue: 'cover',
          },
          {
            type: 'background-repeat',
            label: 'templateBuilder.fields.backgroundImageOptions.filling.label',
            options: [
              {
                label: 'templateBuilder.fields.backgroundImageOptions.filling.options.noRepeat',
                value: 'no-repeat',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.filling.options.repeat',
                value: 'repeat',
              },
            ],
            defaultValue: 'no-repeat',
          },
        ],
      },
    };
  } if (type === BackgroundImageOptionTypeEnum.SELECTOR_WITH_SIZE_REPEAT) {
    return {
      componentName,
      options: {
        type,
        label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.label',
        options: [
          {
            label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.options.fullWidth',
            value: 'full-width',
          },
          {
            label: 'templateBuilder.fields.backgroundImageOptions.displayBackgroundOn.options.centerOnly',
            value: '.container',
          },
        ],
        defaultValue: 'full-width',
        list: [
          {
            type: 'background-size',
            label: 'templateBuilder.fields.backgroundImageOptions.size.label',
            options: [
              {
                label: 'templateBuilder.fields.backgroundImageOptions.size.options.cover',
                value: 'cover',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.size.options.auto',
                value: 'auto',
              },
            ],
            defaultValue: 'cover',
          },
          {
            type: 'background-repeat',
            label: 'templateBuilder.fields.backgroundImageOptions.filling.label',
            options: [
              {
                label: 'templateBuilder.fields.backgroundImageOptions.filling.options.noRepeat',
                value: 'no-repeat',
              },
              {
                label: 'templateBuilder.fields.backgroundImageOptions.filling.options.repeat',
                value: 'repeat',
              },
            ],
            defaultValue: 'no-repeat',
          },
        ],
      },
    };
  }
  return {
    componentName,
    options: {
      type,
      list: [
        {
          type: 'background-size',
          label: 'templateBuilder.fields.backgroundImageOptions.size.label',
          options: [
            {
              label: 'templateBuilder.fields.backgroundImageOptions.size.options.cover',
              value: 'cover',
            },
            {
              label: 'templateBuilder.fields.backgroundImageOptions.size.options.auto',
              value: 'auto',
            },
          ],
          defaultValue: 'cover',
        },
        {
          type: 'background-position',
          label: 'templateBuilder.fields.backgroundImageOptions.position.label',
          options: [
            {
              label: 'templateBuilder.fields.backgroundImageOptions.position.options.center',
              value: 'center',
            },
            {
              label: 'templateBuilder.fields.backgroundImageOptions.position.options.top',
              value: 'top',
            },
            {
              label: 'templateBuilder.fields.backgroundImageOptions.position.options.bottom',
              value: 'bottom',
            },
            {
              label: 'templateBuilder.fields.backgroundImageOptions.position.options.left',
              value: 'left',
            },
            {
              label: 'templateBuilder.fields.backgroundImageOptions.position.options.right',
              value: 'right',
            },
          ],
          defaultValue: 'center',
        },
        {
          type: 'background-repeat',
          label: 'templateBuilder.fields.backgroundImageOptions.filling.label',
          options: [
            {
              label: 'templateBuilder.fields.backgroundImageOptions.filling.options.noRepeat',
              value: 'no-repeat',
            },
            {
              label: 'templateBuilder.fields.backgroundImageOptions.filling.options.repeat',
              value: 'repeat',
            },
            {
              label: 'templateBuilder.fields.backgroundImageOptions.filling.options.repeatX',
              value: 'repeat-x',
            },
            {
              label: 'templateBuilder.fields.backgroundImageOptions.filling.options.repeatY',
              value: 'repeat-y',
            },
          ],
          defaultValue: 'no-repeat',
        },
      ],
    },
  };
};

export default getBackgroundImageFieldConfig;
